// (e) Attempt ladder indicator: "Attempt N of 3" + what's unlocked.
interface AttemptBarProps {
  attemptIndex: number; // 1..3
  /** The ladder closed in Pink and opened the question's scaffold. */
  scaffold?: boolean;
}

const SUBTITLE: Record<number, string> = {
  1: 'Give it your best shot',
  2: 'Hints unlocked',
  3: 'Video and theory unlocked',
};

export function AttemptBar({ attemptIndex, scaffold = false }: AttemptBarProps) {
  const subtitle = scaffold ? 'Scaffolding unlocked' : (SUBTITLE[attemptIndex] ?? '');
  return (
    <div className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2">
      <span className="text-sm font-semibold text-ink">
        Attempt {attemptIndex} of 3
        <span className="ml-2 font-normal text-slate-500">— {subtitle}</span>
      </span>
      <div className="flex gap-1" aria-hidden>
        {[1, 2, 3].map((n) => (
          <span
            key={n}
            className={`h-1.5 w-6 rounded-full ${n <= attemptIndex ? 'bg-slate-800' : 'bg-slate-200'}`}
          />
        ))}
      </div>
    </div>
  );
}
